<template>
  <div class="max-w-lg w-full mx-auto">
    <div class="flex flex-wrap -mx-2">
      <div class="mt-16 mx-auto max-w-7xl px-4 sm:mt-24 sm:px-6" v-if="errorMessage == null">
        <div class="text-center">
          <h1 class="text-2xl tracking-tight font-black text-gray-900 sm:text-3xl">
            <span class="block">Your images are ready!</span><br/>
            <span class="block text-mygrad text-xl md:text-2xl">
              Click the button below to download the images, this can take a while...!
            </span>
          </h1>
        </div>
      </div>
      <div class="mt-8 mx-auto py-3 max-w-7xl w-full" v-if="errorMessage == null">
        <div class="text-center w-full h-auto">
          <label class="block text-left text-sm font-medium text-gray-700 mb-2" for="download-email">
            Email used for the order
          </label>
          <input
            id="download-email"
            v-model.trim="email"
            type="email"
            autocomplete="email"
            class="mb-4 block w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500"
          >
          <p v-if="validationMessage" class="mb-4 text-sm text-red-700">
            {{ validationMessage }}
          </p>
          <button
            @click="submit"
            type="submit"
            :disabled="!canSubmit"
            class="inline-flex items-center justify-center px-4 py-2 w-full border border-blue-300 shadow-sm text-lg font-medium rounded-md text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Download!
          </button>
        </div>
      </div>
      <div class="mt-8 mx-auto py-3 max-w-7xl w-full" v-else>
        <div class="text-center w-full h-auto">
          <h2 class="text-2xl tracking-tight font-extrabold text-gray-900 sm:text-3xl md:text-4xl">
            <span class="block">{{ errorMessage }}</span>
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "Download",
  props: {},
  data: function() {
    return {
      errorMessage: null,
      validationMessage: "",
      email: "",
    };
  },
  computed: {
    canSubmit() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    },
  },
  methods: {
    submit() {
      if (!this.canSubmit) {
        this.validationMessage = "Enter the email used for the order.";
        return;
      }
      this.validationMessage = "";

      axios
        .post(
          `${process.env.VUE_APP_SNAPSHOT_API_BASE}/download-digitals`,
          {
            order_nano_id: this.$route.params.nanoId,
            email: this.email,
          }
        )
        .then((r) => {
          this.errorMessage = "Your download should start shortly - your browser will handle the rest!";
          window.location.href = r.data.url;
        })
        .catch((e) => {
          this.errorMessage = e?.response?.data?.message || e?.response?.data?.error || "We could not verify this order.";
        });
    },
  },
};
</script>
